import { Provider } from 'react-redux';
import { i18nReducer, loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { combineReducers } from 'redux';

import { createStore } from '@common/utils/redux';
import { setAppConfig } from "@common/utils/config";

import { individualsEN } from './translations/en';
import { individualsES } from './translations/es';
import { individualsJA } from './translations/ja';
import { Individuals } from './individuals';
import { mountReactNode } from '@common/utils/react';

export * from './individuals';

export const initIndividuals = (
  componentId,
  locale,
  liveSearchEnabled,
  liveSearchDelay
) => {
  try {
    const store = createStore(combineReducers({ i18n: i18nReducer }));
    syncTranslationWithStore(store);

    setAppConfig({
      individuals: {
        liveSearchEnabled,
        liveSearchDelay,
      }
    });
  
    const translation = {
      en: individualsEN,
      ja: individualsJA,
      es: individualsES,
    };
  
    if (!translation[locale]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
  
    mountReactNode(
      <Provider store={store}>
        <Individuals />
      </Provider>,
      document.getElementById(componentId)
    );
  } catch(err) {
    throw err;
  }
};